import axios from 'axios';
import { ALERTS_FETCHED, FETCHING_ALERTS_FAILED } from '../../actions/actionTypes';

const alertsFetched = (alerts) => ({
    type: ALERTS_FETCHED,
    alerts
});

const fetchingAlertsFailed = () => ({
    type: FETCHING_ALERTS_FAILED
});

/* eslint-disable import/prefer-default-export */
export const fetchAlerts = (location) => {
    return async (dispatch) => {
        if (!location) {
            // Don't fetch when location is null
            alertsFetched([]);
        }
        else {
            try {
                const query = `?location_id=${location.location_id}&location_type=${location.location_type}`;
                const url = `${process.env.API}/communication/external/alert${query}`;

                const response = await axios.get(url);
                const alerts = response.data.alerts;

                dispatch(alertsFetched(alerts));
            }
            catch (error) {
                fetchingAlertsFailed();
            }
        }
    };
};
/* eslint-enable import/prefer-default-export */
